// extracted by mini-css-extract-plugin
export default {"rows":"styles_rows__gv2DQ","row":"styles_row__Z8ZYp","text":"styles_text__BSQUD","label":"styles_label__XOA6y","hint":"styles_hint__tebya","note":"styles_note__OoCVQ"};